module.exports = __webpack_public_path__ + "static/media/Mario.8b1c35a6.png";